import { createAction } from '@reduxjs/toolkit'
import type { IFeedbackFormValues } from './interfaces'

export declare namespace NAction {
  interface ICheckPhoneValue {
    values: IFeedbackFormValues
  }
}

export const sendFeedback = createAction<IFeedbackFormValues>('@@feedback/SEND_FEEDBACK')
